import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { dayjs } from '@app/shared/functions/date-time.functions';

@Injectable()
export class DayjsDateAdapter extends NativeDateAdapter {
  override setLocale(locale: string): void {
    super.setLocale(locale);
    dayjs.locale(locale.toLowerCase().split('-')[0]);
  }

  override parse(value: unknown, parseFormat?: string | string[]): Date | null {
    if (value instanceof Date) {
      return this.isValid(value) ? value : null;
    }

    if (typeof value === 'string') {
      const trimmedValue = value.trim();
      if (trimmedValue.length === 0) {
        return null;
      }

      const formats = Array.isArray(parseFormat) ? parseFormat : [parseFormat];
      const parsed = [...formats, 'DD.MM.YYYY', 'MM/YYYY', 'YYYY-MM-DD']
        .filter((format): format is string => typeof format === 'string')
        .map((format) => dayjs(trimmedValue, format, true))
        .find((date) => date.isValid());

      if (parsed) {
        return parsed.toDate();
      }

      const fallback = dayjs(trimmedValue);
      return fallback.isValid() ? fallback.toDate() : null;
    }

    if (typeof value === 'number') {
      const parsed = dayjs(value);
      return parsed.isValid() ? parsed.toDate() : null;
    }

    return null;
  }

  override format(date: Date, displayFormat: string): string {
    if (!this.isValid(date)) {
      throw new Error('Cannot format invalid date.');
    }

    return dayjs(date).format(displayFormat);
  }

  override deserialize(value: unknown): Date | null {
    if (typeof value === 'string') {
      const parsed = dayjs(value);
      return parsed.isValid() ? parsed.toDate() : null;
    }

    return super.deserialize(value);
  }
}
